import { Alert, Stack, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { PAGE_MAX_WIDTH } from "@/providers/DrawerProvider";

export const STRIPE_BLOCKED_MESSAGE =
  "Checkout and account verification are unavailable while connected through a Webshare proxy — disconnect your proxy to use these features.";

/**
 * Full-width warning shown on every dashboard page while Stripe.js cannot be
 * loaded — the shopper is browsing through a Webshare proxy, which blocks
 * js.stripe.com (r-1956). The rest of the dashboard keeps working; only the
 * Stripe-backed flows (checkout, account verification) are unavailable.
 *
 * Purely presentational — `Banners` decides when it shows.
 */
export default function StripeBlockedBanner() {
  return (
    <Alert
      severity="warning"
      icon={false}
      data-testid="stripe-blocked-banner"
      sx={{
        p: 0,
        borderRadius: 0,
        borderTop: 1,
        borderBottom: 1,
        borderColor: "divider",
      }}
      slotProps={{ message: { sx: { p: 0, width: "100%" } } }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          maxWidth: PAGE_MAX_WIDTH,
          mx: "auto",
          py: 2,
          px: { xs: 3, lg: 4 },
        }}
      >
        <Warning fontSize="small" sx={{ color: "warning.dark" }} />
        <Typography variant="body2" fontWeight={500}>
          {STRIPE_BLOCKED_MESSAGE}
        </Typography>
      </Stack>
    </Alert>
  );
}
